import { render, staticRenderFns } from "./OrderableErrorPreviewDialog.vue?vue&type=template&id=4a467a5c&"
import script from "./OrderableErrorPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderableErrorPreviewDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports